import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  return (
    <footer
      className={styles.footer}
      style={{
        backgroundImage: 'url(/assets/backgrounds/gradient-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
      }}
    >
      <div className={styles.container}>
        <div className={styles.logoRow}>
          <div className={styles.logoCol}>
            <img src="/assets/images/logo.png" alt="Brands2Buyers" className={styles.logo} />
          </div>
          <div className={styles.linkedinCol}>
            <a href="https://www.linkedin.com/company/brands2buyers" target="_blank" rel="noopener noreferrer">
              <img src="/assets/images/linkedin-icon.jpg" alt="LinkedIn" className={styles.linkedinIcon} />
            </a>
          </div>
        </div>
        <p className={styles.contact}>
          <strong>Contact :</strong> hello@brands2buyers.io
        </p>
        <Link to="/mentions-legales" className={styles.legalLink}>Mentions légales</Link>
        <p className={styles.copyright}>
          © 2025 Brands2Buyers. Images created with AI.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
